import React from "react";

const ShortenRegularIcon = ({
  svgRef,
  ...props
}) => /*#__PURE__*/React.createElement("svg", Object.assign({
  width: 16,
  height: 16,
  viewBox: "0 0 16 16",
  fill: "none",
  ref: svgRef
}, props, {
  className: "transform-gpu " + (props.className || "")
}), /*#__PURE__*/React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M2.19941 6.19995C1.89566 6.19995 1.64941 6.44619 1.64941 6.74995C1.64941 7.05371 1.89566 7.29995 2.19941 7.29995H13.7994C14.1032 7.29995 14.3494 7.05371 14.3494 6.74995C14.3494 6.44619 14.1032 6.19995 13.7994 6.19995H2.19941ZM2.19941 9.19995C1.89566 9.19995 1.64941 9.44619 1.64941 9.74995C1.64941 10.0537 1.89566 10.3 2.19941 10.3H7.79941C8.10317 10.3 8.34941 10.0537 8.34941 9.74995C8.34941 9.44619 8.10317 9.19995 7.79941 9.19995H2.19941Z",
  fill: "currentColor"
}));

const ForwardRef = React.forwardRef((props, ref) => /*#__PURE__*/React.createElement(ShortenRegularIcon, Object.assign({
  svgRef: ref
}, props)));
export default ForwardRef;